import { Injectable } from '@angular/core';
import {
  ErrorCodeEntry,
  ErrorCodeTranslationService,
} from 'src/app/shared/services/errorcode-translation.service';

@Injectable({
  providedIn: 'root',
})
export class PlayerErrorService {
  constructor(
    private errorCodeTranslationService: ErrorCodeTranslationService
  ) {}

  async getErrorMessage(errorCode: string): Promise<ErrorCodeEntry> {
    return await this.errorCodeTranslationService.getErrorByCode(
      errorCode,
      'Something went wrong. We are working on it. Please try again in a bit.'
    );
  }

  getLocalizedMessage(error: ErrorCodeEntry): string {
    return this.errorCodeTranslationService.getLocalizedMessage(error);
  }
}
